import React from "react";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { getUsageCategoryList, Usage, UsageMetric } from "../types/Usage";
import UsageCard from "./UsageCard";
import { sortUsageCategories } from "./charts/UsageBarChart";

const UsageCategoryList = getUsageCategoryList();

interface UsageCardsProps {
  metric: UsageMetric;
  usage: Usage;
}

export default function UsageCards(props: UsageCardsProps): React.JSX.Element {
  const { i18n } = useTranslation();

  const sortedCategoriesList = sortUsageCategories(UsageCategoryList, props.usage, props.metric, i18n);

  return (
    <>
      {sortedCategoriesList.length && 
        <Stack
          direction="row"
          sx={{
            flexWrap: "wrap",
            gap: 1
          }}>
          {sortedCategoriesList.map((key): React.JSX.Element => {
            return (
              <UsageCard key={key} metric={props.metric} usage={props.usage} usageCategoryKey={key} />
            )
          })}
        </Stack>
      }
    </>
  );
}